module.exports = __webpack_public_path__ + "static/design-detail.0259aa94.svg";